import dynamic from 'next/dynamic'

const DynamicDevTools = dynamic(() => import('./DevTools'))

export default DynamicDevTools
